import { Typography } from "@material-ui/core";
import { formatCurrency } from "../../shared/utils";
import TablaVehiculos from "./tablaVehiculos";
import useStyles from "./resumenCotizacionStyles";

const ResumenCotizacion = ({ cotizacionData, solicitud }) => {
  const classes = useStyles();
  const data = cotizacionData || {};

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        Detalle de la cotización
      </Typography>
      <div className={classes.grid}>
        <div className={classes.campo}>
          <Typography className={classes.value}>{solicitud ?? "-"}</Typography>
          <Typography className={classes.label}>Numero de solicitud</Typography>
        </div>
        <div className={classes.campo}>
          <Typography className={classes.value}>
            {formatCurrency(data.totalPremiumFleetSubsequent)}
          </Typography>
          <Typography className={classes.label}>Prima total</Typography>
        </div>
        <div className={classes.campo}>
          <Typography className={classes.value}>
            {formatCurrency(data.vatFleetSubsequent)}
          </Typography>
          <Typography className={classes.label}>IVA</Typography>
        </div>
        <div className={classes.campo}>
          <Typography className={classes.value}>
            {formatCurrency(data.netPremiumFleetSubsequent)}
          </Typography>
          <Typography className={classes.label}>Prima neta</Typography>
        </div>
        <div className={classes.campo}>
          <Typography className={classes.value}>
            {data.fleetSize ?? "-"}
          </Typography>
          <Typography className={classes.label}>Numero de vehículos</Typography>
        </div>
      </div>
      <TablaVehiculos vehiclePremiums={data.vehiclePremiums} />
    </div>
  );
};

export default ResumenCotizacion;
